(() => {
  const publish = (name, data) => {
    const shopify = window.Shopify;
    if (!shopify?.analytics?.publish || shopify.designMode || shopify.theme?.role !== 'main') return false;
    if (!shopify.customerPrivacy?.analyticsProcessingAllowed?.()) return false;
    try { shopify.analytics.publish(`roots_roads:${name}`, data); return true; } catch (_) { return false; }
  };
  document.addEventListener('rr:country-search', (event) => {
    publish('country_finder_used', { result_count: event.detail.resultCount, placement: event.detail.mode });
  });
  document.addEventListener('click', (event) => {
    const link = event.target instanceof Element ? event.target.closest('a[href]') : null;
    if (!link) return;
    const url = new URL(link.href, location.origin);
    if (url.origin !== location.origin || !url.pathname.startsWith('/collections/')) return;
    publish('collection_explored', { collection_path: url.pathname, placement: link.closest('[data-rr-country-finder]') ? 'country_finder' : link.closest('header') ? 'navigation' : 'content' });
  });
  const reached = new Set();
  let scheduled = false;
  const measure = () => {
    scheduled = false;
    const height = document.documentElement.scrollHeight - innerHeight;
    if (height <= 0) return;
    const depth = Math.round(scrollY / height * 100);
    [50, 90].forEach((threshold) => {
      if (depth >= threshold && !reached.has(threshold)) {
        if (publish('scroll_depth', { percent: threshold, page_type: document.body.dataset.rrPageType || 'store' })) reached.add(threshold);
      }
    });
  };
  addEventListener('scroll', () => {
    if (!scheduled) { scheduled = true; requestAnimationFrame(measure); }
  }, { passive: true });
})();
